var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDispatchBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.550004,
    width: 73.9357,
    height: 73.9356,
    rx: 36.9678,
    fill: "#020407",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.550004,
    width: 73.9357,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint0_linear_706_70404)",
    strokeWidth: 1.07657
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.550004,
    width: 73.9357,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint1_linear_706_70404)",
    strokeWidth: 1.07657
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_70404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0746 44.9713H53.0123V39.0306C53.0123 38.3355 52.8026 37.6535 52.4134 37.0765L49.7512 33.1335C49.0998 32.1718 48.0158 31.5947 46.8529 31.5947H42.7263C42.2411 31.5947 41.852 31.9881 41.852 32.469V44.9714H35.0937C35.7363 45.5265 36.1778 46.3003 36.3046 47.1746H43.4301C43.6836 45.4392 45.1787 44.0971 46.9841 44.0971C48.7895 44.0971 50.2802 45.4392 50.5338 47.1746H54.0746C54.3151 47.1746 54.5118 46.9779 54.5118 46.7375V45.4085C54.5117 45.1681 54.3151 44.9713 54.0746 44.9713ZM49.7206 37.8634H44.2737C44.0333 37.8634 43.8366 37.671 43.8366 37.4262V34.4055C43.8366 34.1651 44.0333 33.9684 44.2737 33.9684H47.5917C47.736 33.9684 47.8671 34.0383 47.9502 34.152L50.0791 37.177C50.2801 37.4656 50.0747 37.8634 49.7206 37.8634ZM46.9841 44.9713C45.4803 44.9713 44.265 46.1909 44.265 47.6947C44.265 49.1942 45.4803 50.4138 46.9841 50.4138C48.4834 50.4138 49.7031 49.1942 49.7031 47.6947C49.7031 46.191 48.4834 44.9713 46.9841 44.9713ZM46.9841 49.0544C46.2321 49.0544 45.6245 48.4424 45.6245 47.6949C45.6245 46.9429 46.2321 46.3353 46.9841 46.3353C47.7359 46.3353 48.3436 46.9429 48.3436 47.6949C48.3436 48.4424 47.7359 49.0544 46.9841 49.0544ZM24.3136 44.9713C24.0732 44.9713 23.8764 45.1681 23.8764 45.4085V46.7375C23.8764 46.9779 24.0732 47.1746 24.3136 47.1746H29.2009C29.3277 46.3003 29.7692 45.5265 30.4074 44.9714H24.3136V44.9713ZM32.7505 44.9713C31.2511 44.9713 30.0314 46.1909 30.0314 47.6947C30.0314 49.1942 31.2511 50.4138 32.7505 50.4138C34.2543 50.4138 35.4696 49.1942 35.4696 47.6947C35.4696 46.191 34.2543 44.9713 32.7505 44.9713ZM32.7505 49.0544C31.9986 49.0544 31.391 48.4424 31.391 47.6949C31.391 46.9429 31.9986 46.3353 32.7505 46.3353C33.5024 46.3353 34.1101 46.9429 34.1101 47.6949C34.1101 48.4424 33.5024 49.0544 32.7505 49.0544ZM39.2903 28.8844H34.2237C34.4729 29.6231 34.6041 30.4144 34.6041 31.2319C34.6041 35.3585 31.2468 38.7158 27.1201 38.7158C26.3682 38.7158 25.6382 38.6022 24.9518 38.3967V43.2272C24.9518 43.4676 25.1486 43.6644 25.389 43.6644H40.1646C40.4051 43.6644 40.6017 43.4676 40.6017 43.2272V30.1958C40.6017 29.4701 40.0159 28.8844 39.2903 28.8844ZM27.1211 24.6211C23.4708 24.6211 20.5117 27.5801 20.5117 31.2304C20.5117 34.8807 23.4708 37.8398 27.1211 37.8398C30.7714 37.8398 33.7306 34.8807 33.7306 31.2304C33.7306 27.5801 30.7714 24.6211 27.1211 24.6211ZM27.1211 36.3358C24.3016 36.3358 22.0158 34.05 22.0158 31.2304C22.0158 28.4108 24.3016 26.1251 27.1211 26.1251C29.9407 26.1251 32.2264 28.4109 32.2264 31.2304C32.2264 34.05 29.9407 36.3358 27.1211 36.3358ZM29.0709 32.3086C29.0146 32.3086 28.9569 32.3014 28.8997 32.286L26.7696 31.7119C26.4836 31.6346 26.2846 31.3751 26.2846 31.0788V27.8001C26.2846 27.4381 26.5783 27.1444 26.9403 27.1444C27.3023 27.1444 27.5961 27.4381 27.5961 27.8001V30.5763L29.2413 31.0198C29.5909 31.1141 29.7979 31.4741 29.7036 31.8236C29.6247 32.1161 29.36 32.3086 29.0709 32.3086Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_70404",
    x1: -8.1608,
    y1: 4.24628,
    x2: 74.7156,
    y2: 75.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_70404",
    x1: 89.8391,
    y1: 91.9622,
    x2: 2.72812,
    y2: 30.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_70404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.0001,
    height: 34,
    fill: "white",
    transform: "translate(20.5117 20.5176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatchBoard);
export default __webpack_public_path__ + "static/media/DispatchBoard.0f8dc4591f8c3410f38ab64c95e78d0c.svg";
export { ForwardRef as ReactComponent };